import { AnnualTaxesContent } from './AnnualTaxesContent'

interface Props {
  feature: 'annual-taxes'
}

/**
 * Displays a CTA "upgrade" card for a specific feature
 * e.g. When a user's subscription does not include Annual Taxes, we render this component
 * to advertise the feature & potentially capture an upgrade
 *
 * Extendable for future features by adding a type onto props and rendering its specific html
 */
export const UpgradeToPremiumModal: React.FC<Props> = ({ feature }) => {
  let content

  switch (feature) {
    case 'annual-taxes':
      content = <AnnualTaxesContent />
      break
    default:
      content = null
  }

  return (
    <div className="flex flex-col items-center justify-center h-full w-full background-priority-1">
      {content}
    </div>
  )
}
